import { Position } from "@/models/positions.model";
import { Module } from "vuex";
import { RootState } from "..";
import { actions } from "./positions.actions";
import { mutations } from "./positions.mutations";

export interface PositionsState {
  positions: Position[];
}

const state: PositionsState = {
  positions: []
};

export const namespacePositions = "positions";

export const positionsModule: Module<PositionsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};

export * from "./positions.actions";
export * from "./positions.mutations";
